import { fetchData, PaginationParameters, PaginationResponse } from "@request";
import { getQueryParams } from "@request/helpers";

export type AdminWithdrawal = {
  address: string;
  amount: number;
  commission: number;
  created: string;
  status: string;
  email: string;
  hash: string;
  id: string;
  role: string;
};

export type AdminWithdrawalsResponse = PaginationResponse<{
  withdrawals: AdminWithdrawal[];
}>;

export type AdminWithdrawalsRequest = PaginationParameters<{
  address?: string;
  user?: string;
  status?: boolean;
}>;

export const getAdminWithdrawalsApi = async (
  data?: AdminWithdrawalsRequest
) => {
  try {
    const queryParams = getQueryParams(data);
    const response = await fetchData<AdminWithdrawalsResponse>({
      url: `api/v1/admin/withdrawals?${queryParams}`,
    });

    return response;
  } catch (error) {
    console.error("getAdminWithdrawalsApi failed:", error);
    throw error;
  }
};

export type AdminWithdrawalUpdateRequest = {
  cancel?: boolean;
  hash?: string;
  our_address?: string;
};

export const updateAdminWithdrawalApi = async (
  withdrawalId: string,
  data: AdminWithdrawalUpdateRequest
) => {
  try {
    const response = await fetchData<string>({
      url: `api/v1/admin/withdrawals/${withdrawalId}`,
      method: "PUT",
      data,
    });

    return response;
  } catch (error) {
    console.error("updateAdminWithdrawalApi failed:", error);
    throw error;
  }
};
